import React from "react";

export default function SuggestionCard({ suggestion }) {
  const handleApprove = () => alert(`Approved ${suggestion.name}`);
  const handleReject = () => alert(`Rejected ${suggestion.name}`);

  return (
    <div className="border p-4 rounded mb-2">
      <h2 className="text-xl">{suggestion.name}</h2>
      <p className="text-sm text-gray-600">Submitted by {suggestion.submittedBy}</p>
      <div className="mt-2">
        <button onClick={handleApprove} className="bg-green-500 text-white px-2 py-1 mr-2 rounded">
          Approve
        </button>
        <button onClick={handleReject} className="bg-red-500 text-white px-2 py-1 rounded">
          Reject
        </button>
      </div>
    </div>
  );
}
